import styles from './styles/PhotoGalleryAlertModal.module.scss';
import PhotoGalleryCopyrightNotice from './PhotoGalleryCopyrightNotice';
import PhotoGalleryPurchaseConfirmation from './PhotoGalleryPurchaseConfirmation';
import PhotoGalleryLicenseAgreement from './PhotoGalleryLicenseAgreement';
import PhotoGalleryPhotoNotForSale from './PhotoGalleryPhotoNotForSale';
import { usePhotoGalleryContainer } from '..';

export enum PhotoGalleryAlertTypeEnum {
  'COPYRIGHT_NOTICE' = 'copyright_notice',
  'PURCHASE_CONFIRMATION' = 'purchase_confirmation',
  'PHOTO_LICENSE_AGREEMENT' = 'photo_license_agreement',
  'PHOTO_UNAVAILABLE_FOR_PURCHASE' = 'photo_unavailable_for_purchase'
}

export default function PhotoGalleryAlertModal() {
  const [{ alertType }, { setAlertType }] = usePhotoGalleryContainer();
  let AlertContent;
  switch (alertType) {
    case PhotoGalleryAlertTypeEnum.COPYRIGHT_NOTICE:
      AlertContent = PhotoGalleryCopyrightNotice;
      break;
    case PhotoGalleryAlertTypeEnum.PURCHASE_CONFIRMATION:
      AlertContent = PhotoGalleryPurchaseConfirmation;
      break;
    case PhotoGalleryAlertTypeEnum.PHOTO_LICENSE_AGREEMENT:
      AlertContent = PhotoGalleryLicenseAgreement;
      break;
    case PhotoGalleryAlertTypeEnum.PHOTO_UNAVAILABLE_FOR_PURCHASE:
      AlertContent = PhotoGalleryPhotoNotForSale;
      break;
  }
  if (!AlertContent) {
    return null;
  }

  return (
    <div className={styles.ModalBackground}>
      <div className={styles.ModalContent}>
        <AlertContent />
      </div>
    </div>
  );
}
